<template>
    <div>
        <h1 style="font-size: 24px; color: black;">商品管理</h1>
        <el-card class="form-container" shadow="never">
            <el-form :inline="true" :model="queryData" size="small" label-width="120px">
                <el-form-item label="日期：">
                    <el-date-picker
                            v-model="queryData.timeDate"
                            type="daterange"
                            :clearable="false"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            value-format="yyyy-MM-dd">
                    </el-date-picker>&emsp;&emsp;
                </el-form-item>
                <el-form-item label="商品名称：">
                    <el-input v-model="queryData.name" style="width: 110px" clearable></el-input>
                </el-form-item>
                <el-form-item label="商品类型：">
                    <el-select v-model="queryData.type" >
                        <el-option v-for="item in goodType" :key="item.id" :value="item.id" :label="item.name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="商品来源:">
                    <el-select v-model="queryData.origin" clearable>
                        <el-option v-for="item in origins" :key="item.id" :value="item.id" :label="item.name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label=" ">
                    <el-button  type="primary" @click="queryGoodsList">查询</el-button>
                    <el-button  type="primary" @click="importExcel">导出</el-button>
                    <el-button  type="primary" @click="showDetails('新增商品')">新增</el-button>
                </el-form-item>
                <el-form-item >
                    <el-upload :action="upload()" :headers="headers"
                               :on-success="handleZipSuccess"
                               :before-upload="beforeZipUpload"
                               :show-file-list="false"
                               v-loading.fullscreen.lock="loading"
                               ref="upload">
                        <el-button  type="primary">批量上传</el-button>
                    </el-upload>

                </el-form-item>
            </el-form>
        </el-card>
        <h1>
            <el-table border
                      :data="goodsList"
                      ref="filterTable"
                       @sort-change='sortChange'>
                <el-table-column  label="日期" prop="dtUpdate" :formatter="formatDate" width="160px"></el-table-column>
                <el-table-column prop="origin"  label="平台来源" width="100px" :formatter="formatOrigin" > </el-table-column>
                <el-table-column  label="商品类型" prop="goodsType.name" width="100px"></el-table-column>
                <el-table-column  label="商品名称" prop="name" width="90px"></el-table-column>
                <el-table-column  label="商品图片" width="150px" align="center">
                    <template slot-scope="scope">
                        <template>
                            <img :src="VUE_APP_CDN_URL+scope.row.goodImg" width="80px" height="80px" />
                        </template>
                    </template>
                </el-table-column>
                <el-table-column  label="规格/面值" prop="goodValue" width="90px"></el-table-column>
                <el-table-column  label="单品编码" prop="goodCode" width="137px"></el-table-column>
                <el-table-column  label="标准价" prop="price" width="100px"></el-table-column>
                <el-table-column  label="供货价" prop="discountPrice" sortable="custom" width="100px"></el-table-column>
                <el-table-column  label="商品详情"  width="120px">
                    <template slot-scope="scope">
                        <el-button type="text" @click.native.stop="checkGoodDesc(scope.row)" >查看</el-button>
                    </template>
                </el-table-column>
                <el-table-column  label="红包币兑换" width="113px" prop="coinNumber"></el-table-column>
                <el-table-column  label="每人限购数量" width="143px">
                    <template slot-scope="scope" >
                        <el-input-number size="small" :min="0" style="width: 110px" v-model="scope.row.limitPerson"  @change="update(scope.row)"></el-input-number>
                    </template>
                </el-table-column>
                <el-table-column  label="每天限购总量" width="143px">
                    <template slot-scope="scope" >
                        <el-input-number size="small" :min="0" style="width: 110px" v-model="scope.row.limitDay"  @change="update(scope.row)"></el-input-number>
                    </template>
                </el-table-column>
                <el-table-column  label="操作" width="120px" align="center">
                    <template slot-scope="scope">
                    <el-button  plain size="mini" type="primary" @click="showDetails('编辑商品',scope.row)">编辑</el-button>
                    </template >
                </el-table-column>

            </el-table>
            <el-row>
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="page.page"
                        :page-sizes="[20,50,100]"
                        :page-size="page.size"
                        layout="total, sizes, prev, pager, next"
                        :total="page.totalElements">
                </el-pagination>
            </el-row>
        </h1>
        <el-dialog :title="dialogTitle" center :visible.sync="dialogVisible" width="700px">
            <el-form :model="goodEditForm" label-width="150px">
                <el-form-item label="商品名称:" >
                    <el-input  style="width: 300px" type="text" v-model="goodEditForm.name"></el-input>
                </el-form-item>
                <el-form-item label="商品来源:" >
                    <el-select  v-model="goodEditForm.origin">
                        <el-option
                                v-for="item in origins"
                                :label="item.name"
                                :value="item.id"
                                :key="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="商品类型:" >
                    <el-select  v-model="goodEditForm.goodsType">
                        <el-option
                                v-for="item in goodType"
                                :label="item.name"
                                :value="item.id"
                                :key="item.id"
                                :disabled="item.disabled">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="商品规格/面值:" >
                    <el-input  style="width: 300px" type="text" v-model="goodEditForm.goodValue"></el-input>
                </el-form-item>
                <el-form-item label="商品编码:" >
                    <el-input  style="width: 300px" type="text" v-model="goodEditForm.goodCode"></el-input>
                </el-form-item>
                <el-form-item label="商品图片 :" >
                    <el-upload
                            :headers="headers"
                            class="avatar-uploader"
                            :action="uploadURL"
                            :show-file-list="false"
                            :on-success="handleBISuccess"
                            :before-upload="function (file) { return beforeAvatarUpload(file)}"
                            @click="uploadIcon">
                        <img v-if="goodEditForm.goodImg" :src="VUE_APP_CDN_URL+goodEditForm.goodImg" class="avatar">
                        <i v-else class="el-icon-picture avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item label="标准价:" >
                    <el-input-number v-model="goodEditForm.price" :precision="2" :step="0.1" :min="0" ></el-input-number>
                </el-form-item>
                <el-form-item label="供货价:" >
                    <el-input-number v-model="goodEditForm.discountPrice" :precision="2" :step="0.1" :min="0"></el-input-number>
                </el-form-item>
                <el-form-item label="商品详情:" >
                    <el-input type="textarea"
                              :rows="5"
                              placeholder="请输入内容"  v-model="goodEditForm.goodDesc"></el-input>
                </el-form-item>
                <el-form-item label="红包币兑换:" >
                    <el-input-number v-model="goodEditForm.coinNumber"  :min="0" ></el-input-number>
                </el-form-item>
                <el-form-item label="每人限购数量:" >
                    <el-input-number v-model="goodEditForm.limitPerson"  :min="0"></el-input-number>
                </el-form-item>
                <el-form-item label="每天限购数量:" >
                    <el-input-number v-model="goodEditForm.limitDay"  :min="0" ></el-input-number>
                </el-form-item>
                <div style="text-align: center;">
                    <el-button type="primary" @click="confirm">确 定</el-button>
                    <el-button type="info" @click="cancel">取 消</el-button>
                </div>
            </el-form>
        </el-dialog>
        <el-dialog title="商品描述" center :visible.sync="dialogGoodDescVisible" width="50%" :data="desc" >
            <el-row type="info" v-for="(item, index) in desc " :key="index">{{item}}</el-row>
        </el-dialog>
    </div>

</template>

<script>
    import {
        searchGoods,
        saveGoods,
        downloadData,
        gameUpload,
        goodsOriginTypes,
        goodsTypes
} from "@/http/api";
    import utils from '@/utils';
    export default {
        name: "GoodsManagement",
        data(){
            return {
                loading: false,
                VUE_APP_BASE_URL:'',
                VUE_APP_CDN_URL:'',
                headers:{},
                page: {
                    size: 20,
                    page: 1,
                    totalElements: null
                },
                dialogVisible: false,
                dialogTitle :'',
                uploadURL: process.env.VUE_APP_BASE_URL + "game/upload",
                goodEditForm: {},
                queryData: {
                    type: null,
                    name:'',
                    timeDate: ['', ''],
                    origin:null
                },
                queryTrueData: {
                    type: null,
                    startTime: '',
                    endTime: '',
                    order: null,
                    prop: null,
                    origin:null
                },
                goodType: [],
                origins: [],
                messageDialog: {
                    show: false,
                    title: null,
                    message: null
                },
                goodsList: [],
                dialogGoodDescVisible:false,
                desc:[]
            }
        },
        methods :{
            formatDate: function(row, column) {
                return utils.DateUtil.formatDate(row[column.property], "YYYY-MM-DD HH:mm:ss")
            },
            formatOrigin: function(row,column,cellValue) {
                    var temp="其他"
                    this.origins.forEach( item => {
                        if(item.id===cellValue){
                            temp=item.name;
                            } 
                    })
                    return temp
            },
            handleSizeChange(size) {
                this.page.size = size;
                this.queryGoodsList();
            },
            upload() {
                return this.VUE_APP_BASE_URL + 'goods/upload';
            },
            handleCurrentChange(page) {
                this.page.page = page;
                this.queryGoodsList() ;
            },
            handleBISuccess(response){
                this.goodEditForm.goodImg=response.info;
            },
            handleZipSuccess(data) {
                this.loading = false;
                let title;
                if (data.status === 0) {
                    title = "温馨提示";
                } else {
                    title = "错误提示";
                }
                this.messageDialogFun(true, title, data.msg);
                this.queryGoodsList();
            },
            messageDialogFun(show, title, message) {
                this.messageDialog.show = show;
                this.messageDialog.title = title;
                this.messageDialog.message = message;
            },
            beforeZipUpload(data) {
                const type = data.name.substring(data.name.lastIndexOf('.')) === '.zip';
                const size = data.size < 1024 * 1024 * 100;
                if (!type) {
                    this.$message.error('上传zip只能是zip格式!');
                }
                if (!size) {
                    this.$message.error('上传zip大小不能超过100m!');
                }
                let b = type && size;
                if (b) {
                    this.loading = true;
                    this.messageDialogFun(true, '温馨提示', '上传中，请稍候');
                }
                return type && size;
            },
            importExcel(){
                    let fileName = new Date().toLocaleString() + '商品列表.xlsx';
                    downloadData(
                        '/goods/exportExcel',
                        null,
                        fileName
                    )
            },
            checkGoodDesc(_row){
                    this.dialogGoodDescVisible=true;
                    this.desc = _row.goodDesc.split("\n").length===0?['暂无内容']: _row.goodDesc.split("\n")
            },
            beforeAvatarUpload(file) {
                const isIcon = file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg'|| file.type === 'image/gif';
                const isLt2M = file.size / 1024 / 1024 < 1;
                if (!isLt2M) {
                    this.$message.error('上传图片大小不能超过1MB!');
                }
                if (!isIcon) {
                    this.$message.error('上传图片只能是png,jgp,jpeg格式!');
                }
                return isIcon && isLt2M;
            },
            showDetails(title, row) {
                this.goodEditForm = {
                    "id" : 0,
                    "origin" :null,
                    "goodsType" : null,
                    "name" : '',
                    "goodImg" : '',
                    "goodValue" : '',
                    "goodCode" : '',
                    "price" : '',
                    "discountPrice" : '',
                    "coinNumber" : '',
                    "limitDay" : '',
                    "limitPerson" : '',
                    "goodDesc" : '',
                };

                this.dialogTitle = title;
                this.dialogVisible = true;

                if(row){
                    this.goodEditForm = {
                        "id" : row.id,
                        "origin" : row.origin,
                        "goodsType" : row.goodsType.id,
                        "name" : row.name,
                        "goodImg" : row.goodImg,
                        "goodValue" : row.goodValue,
                        "goodCode" : row.goodCode,
                        "price" : row.price,
                        "discountPrice" : row.discountPrice,
                        "coinNumber" : row.coinNumber,
                        "limitDay" : row.limitDay,
                        "limitPerson" : row.limitPerson,
                        "goodDesc" : row.goodDesc,
                    };
                }
            },
            confirm(){
                saveGoods(this.goodEditForm).then(resp=> {
                    if (resp.data.status===0){
                        this.dialogVisible = false;
                        this.queryGoodsList();
                    }
                })
            },
            cancel(){
                this.dialogVisible=false;
            },
            update(row){
                this.goodEditForm = {
                    "id" : row.id,
                    "origin" : row.origin,
                    "goodsType" : row.goodsType.id,
                    "name" : row.name,
                    "goodImg" : row.goodImg,
                    "goodValue" : row.goodValue,
                    "goodCode" : row.goodCode,
                    "price" : row.price,
                    "discountPrice" : row.discountPrice,
                    "coinNumber" : row.coinNumber,
                    "limitDay" : row.limitDay,
                    "limitPerson" : row.limitPerson,
                    "goodDesc" : row.goodDesc,
                };
                saveGoods(this.goodEditForm).then(resp=> {
                    if (resp.data.status===0){
                        this.dialogVisible = false;
                        this.queryGoodsList();
                    }
                })
            },
            editDialogFun(show, title, data) {
                this.editDialog.show = show;
                this.editDialog.title = title;

                this.good.id = 0;
                this.good.origin = null;
                this.good.goodsType = null;
                this.good.name = '';
                this.good.goodImg = null;
                this.good.goodValue = '';
                this.good.goodCode = '';
                this.good.price = '';
                this.good.discountPrice = '';
                this.good.coinNumber = '';
                this.good.limitDay = '';
                this.good.limitPerson = '';
                this.good.goodDesc = '';
                if (show && data) {
                    this.good.id = data.id;
                    this.good.origin = data.origin;
                    this.good.goodsType = data.goodsType.name;
                    this.good.name = data.name;
                    this.good.goodImg = data.goodImg;
                    this.good.goodValue = data.goodValue;
                    this.good.goodCode = data.goodDesc;
                    this.good.price = data.price;
                    this.good.discountPrice = data.discountPrice;
                    this.good.coinNumber = data.coinNumber;
                    this.good.limitDay = data.limitDay;
                    this.good.limitPerson = data.limitPerson;
                    this.good.goodDesc = data.goodDesc;
                }

            },
            uploadIcon(){
                let func = gameUpload;
                func().then().catch(function () {
                })
            },
            sortChange(order) {
                this.queryTrueData.order = order.order;
                this.queryTrueData.prop = utils.StringUtil.humpToUnderline(order.prop);
                this.queryGoodsList();
            },
            queryGoodsList(){
                this.queryTrueData.startTime = this.queryData.timeDate[0];
                this.queryTrueData.endTime = this.queryData.timeDate[1];
                this.queryTrueData.name = this.queryData.name;
                this.queryTrueData.type = this.queryData.type;
                this.queryTrueData.size = this.page.size;
                this.queryTrueData.page = this.page.page;
                this.queryTrueData.origin = this.queryData.origin;
                searchGoods(this.queryTrueData).then(resp => {
                    this.goodsList = resp.data.info.content;
                    this.$forceUpdate();
                    this.page.totalElements = resp.data.info.totalElements;
                });
            }
        },
        created() {
            this.headers ={Authorization : this.$store.state.user.token};
            goodsOriginTypes().then( resp => {
                this.origins =  resp.data.info;
            } )
            goodsTypes().then( resp => {
                this.goodType =  resp.data.info;
            } )
            this.queryGoodsList();
        },
        mounted() {
            this.VUE_APP_BASE_URL=process.env.VUE_APP_BASE_URL;
            this.VUE_APP_CDN_URL= process.env.VUE_APP_CDN_URL;
        }
    }
</script>

<style scoped>

</style>
